<template>
  <div class="title" :class="{ 'title--ribbon': ribbon }">
    <h2>
      <div><slot></slot></div>
      <div v-if="$slots.button"><slot name="button"></slot></div>
    </h2>
  </div>
</template>
<script>
export default {
  props: {
    ribbon: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
